module.exports = __webpack_public_path__ + "img/thumb-q-ai@2x.5a98abf8.png";